import { render, staticRenderFns } from "./notes_app.vue?vue&type=template&id=52ad1987&"
import script from "./notes_app.vue?vue&type=script&lang=js&"
export * from "./notes_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports